import React, { useEffect, type FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";

import { productResourcesActions } from "@fitness-app/app-store";

import { PermissionGuard } from "~/modules/Auth/PermissionGuard";
import { dashboardPermissionRequirements } from "~/modules/Dashboard/dashboardPermissionRequirements";
import { useAppDispatch } from "~/store/initializeStore";
import ResourceEditor from "./components/ResourceEditor/ResourceEditor";
import ResourcesList from "./components/ResourcesList/ResourcesList";

interface OwnProps {
  ownerId?: string;
  readonly?: boolean;
  productId: string;
}

type Props = OwnProps;

const ProductResources: FunctionComponent<Props> = ({ productId, readonly }) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (productId) {
      void dispatch(productResourcesActions.fetchProductResources({ productId }));
      void dispatch(productResourcesActions.fetchResourcesCategories());
    }
  }, [productId, dispatch]);

  return (
    <Routes>
      <Route index element={<ResourcesList productId={productId} readonly={readonly} />} />
      <Route
        path="/:resourceId"
        element={
          <PermissionGuard requirement={dashboardPermissionRequirements.productsResourcesWrite}>
            <ResourceEditor productId={productId} />
          </PermissionGuard>
        }
      />
    </Routes>
  );
};

export default ProductResources;
